import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import AppRoutes from './routes';
import ScrollToTop from './scrollToTop';

const App = () => {
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const inflow = searchParams.get('inflow');

    if (!inflow || !/^\d+$/.test(inflow)) {
      return;
    }

    const domain = window.location.hostname.endsWith('sellerhub.co.kr')
      ? 'Domain=.sellerhub.co.kr; Secure; '
      : '';

    document.cookie =
      `sellerhub_inflow=${encodeURIComponent(inflow)}; ` +
      `Path=/; ` +
      domain +
      `Max-Age=${60 * 60 * 24}; ` +
      `SameSite=Lax`;
  }, [location.search]);

  return (
    <ScrollToTop>
      <AppRoutes />
    </ScrollToTop>
  );
};

export default App;